import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import close from "../../../Assets/closeIcon.svg";
import activeimage from "../../../Assets/image.png";
import unActiveImage from "../../../Assets/unActiveImage.png";
import defaultThanksImage from "../../../Assets/defaultThanksImage.png";
import feather_upload_cloud from "../../../Assets/feather_upload_cloud.png";
import axios from "axios";
import { useParams } from "react-router-dom";
const ThanksModal = ({
  isOpen,
  onClose,
  thanksPageImage,
  setThanksPageImage,
  thanksPageDescription,
  setThanksPageDescription,
  setOpenActionButtion,
  openActionAddButton,
  selectedImageIdx,
  setSelectedImageIdx,
  image,
  setImage,
  onAdd,
  showimageUpLoaded,
  setImageUploaded,
  showSelctedImage,
  setShowSelctedImage,
  handelSelected,
  handleFileChange,
}) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      borderRadius: "15px",
      transform: "translate(-50%, -50%)",
      width: "40%",
      height: "80%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "Space-between",
      gap: "2rem",
      padding: "px !important",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };

  const formId = useParams().formId;
  const [images, setImages] = useState([
    { image: "", text: "Success.jpg" },
    {
      image: "",
      text: "Success1.png",
    },
  ]);

  const getDefaultImage = async (type) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/forms/retrieve`,
        { fileKey: type }
      );
      console.log(response.data);
      return { type, url: response.data.url }; // Include the type and URL in the response
    } catch (error) {
      console.error("Error fetching default image:", error);
      return { type, url: null }; // Return type with null URL for failed requests
    }
  };

  useEffect(() => {
    const fetchImages = async () => {
      const types = images.map((img) => img.text); // Extract types from the initial images array
      try {
        const urls = await Promise.all(
          types.map((type) => getDefaultImage(type))
        );
        const updatedImages = images.map((img) => {
          const urlObj = urls.find((url) => url.type === img.text);
          return {
            ...img,
            image: urlObj?.url || img.image, // Set image URL if available, else keep current
          };
        });
        setImages(updatedImages); // Update state with the new images
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, [formId]); // Trigger fetch on formId change
  console.log(images);

  const uploadFileToS3 = async (file) => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post(
          `${process.env.REACT_APP_API}/forms/thanksimage`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        return response.data.fileUrls.fileKey; // Return the file URL from S3
      } else {
        return "";
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      throw new Error("Failed to upload file");
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
    >
      <div className="thanskModal-container">
        <div className="thanksModal-heading-container">
          <div className="thanskMOdal-heading">Insert image</div>
          <img src={close} alt="close" onClick={onClose} />
        </div>
        <div className="image-chose-contaienr-div">
          <div className="image-choose-container-heading">
            <div className="img-con-chose">
              {showimageUpLoaded ? (
                <img src={activeimage} alt="gallery" />
              ) : (
                <img src={unActiveImage} alt="gallery" />
              )}
              <div
                className="image-choose-container-heading-text"
                style={{ color: showimageUpLoaded ? "#1B51BB" : "#8493B2" }}
                onClick={() => setImageUploaded(true)}
              >
                Gallery
              </div>
            </div>
            <div className="img-con-chose">
              {showimageUpLoaded ? (
                <img src={unActiveImage} alt="gallery" />
              ) : (
                <img src={activeimage} alt="gallery" />
              )}
              <div
                className="image-choose-container-heading-text"
                style={{ color: !showimageUpLoaded ? "#1B51BB" : "#8493B2" }}
                onClick={() => setImageUploaded(false)}
              >
                Upload
              </div>
            </div>
          </div>
          <div className="default-Images-container">
            {showimageUpLoaded ? (
              <>
                {images.map((image, i) => (
                  <div
                    className="default-single-image"
                    style={{
                      backgroundColor:
                        selectedImageIdx === i && "rgba(27, 81, 187, 0.3)",
                    }}
                    key={i}
                    onClick={() => handelSelected(image, i)}
                  >
                    <img src={image.image && image.image} alt="defaultimage" />
                  </div>
                ))}
              </>
            ) : (
              <>
                {showSelctedImage ? (
                  <div className="previewPage-selected-image">
                    <div style={{ width: "45%", height: "10rem" }}>
                      <img
                        src={showSelctedImage}
                        alt="thanksPageImage"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="image-text-btn">
                      <div className="upload-image-name">
                        solo-leveling-anime-smiling-evil-red-eyes-hd-wallpaper-preview.jpg
                      </div>
                      <button onClick={() => setShowSelctedImage("")}>
                        Remove image
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="image-uploaded-local-file">
                    <div className="image-upload-container-textai">
                      <img
                        src={feather_upload_cloud}
                        alt="feather_upload_cloud"
                      />
                      <div className="image-upload-text-continer">
                        <div className="image-upload-text-continer-head">
                          Select a file or drag and drop here
                        </div>
                        <div className="image-upload-text-continer-des">
                          JPG, PNG or PDF, file size no more than 10MB
                        </div>
                      </div>
                    </div>
                    <input
                      type="file"
                      multiple
                      id="file"
                      name="files"
                      onChange={handleFileChange}
                      accept="image/*"
                      className="answer_file_select"
                      style={{ display: "none" }} // Hide the default input
                    />
                    <label
                      htmlFor="file"
                      className="custom-file-label"
                      style={{
                        padding: "10px 20px",
                        color: "#fff",
                        backgroundColor: "rgba(27, 81, 187, 1)",
                        border: "1px solid #007BFF",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Upload file
                    </label>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className="description-thanks-page-container">
          <div className="description-thanks-page-heading">Add description</div>
          <input
            className="description-input-text-style"
            placeholder="Enter Text"
            value={thanksPageDescription}
            onChange={(e) => setThanksPageDescription(e.target.value)}
          />
          <div className="description-thanks-page-des">
            Add alt text for accessibility and SEO purposes. This text will be
            shown if the image can't be loaded.
          </div>
        </div>
        <div className="thanks-action-button-container">
          <button className="cbtn" onClick={onClose}>
            Cancel
          </button>
          <button className="abtn" onClick={onAdd}>
            Add
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default ThanksModal;
